import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { DEFAULT_FOLDER_ID } from '../../../utils/space-url.util';

export { DEFAULT_FOLDER_ID };

export const useResolvedFolderId = (): string => {
  const router = useRouter();

  return useMemo(() => {
    const raw = router.query.folder;
    if (raw === undefined) {
      return DEFAULT_FOLDER_ID;
    }
    return Array.isArray(raw) ? raw[0] : raw;
  }, [router.query.folder]);
};
